module.exports = __webpack_public_path__ + "img/product-bigData-two.a5e9a7a.png";